import Config from 'services/config/local';

// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./history.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * HistoryApi class.
 */
export default class HistoryApi {
    /**
     * @param $http
     * @constructor
     * @ngInject
     */
    constructor($http) {
        this.$http = $http;
        this.config = Config.api.history;
    }

    /**
     * Get History data
     * @returns {promise}
     */
    getList() {
        return this.$http.get(this.config.listUrl).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/api/history/history.service.js